var map = {
	"./ico_brightness+.png": "3707",
	"./ico_brightness-.png": "c21e",
	"./ico_fast_forward.png": "c1c2",
	"./ico_netflix.png": "3f0f",
	"./ico_next.png": "cf1f",
	"./ico_pause.png": "8364",
	"./ico_play.png": "4827",
	"./ico_previous.png": "3a6d",
	"./ico_rewind.png": "b5f8",
	"./ico_stop.png": "57aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2db4";